<template>
  <div>
    <div class="friends_top_bar">
      <span class="friends_tip friends_tip_noac" @click="goTome">个人中心</span>
      <i class="el-icon-arrow-right"></i>
      <span class="friends_tip">我的好友</span>
    </div>

    <div class="friends_sear" style="margin-top: 30px">
      <div class="friends_sear_con">
        <div class="friend_add_in_con">
          <i class="el-icon-search"></i>
          <input
            class="friend_add_in"
            placeholder="请搜索好友"
            v-model="searchInput"
            @keyup.enter="searchFriends"
          />
        </div>
        <button class="friends_start_col_btn" @click="searchFriends">
          搜索
        </button>
      </div>
      <div class="friends_sear_ops_con">
        <span class="me_msg_btn" @click="mygroup">
          <span class="me_msg_text">我的团队</span>
        </span>
        <!-- 创建群聊 -->
        <span class="me_msg_btn">
          <span class="me_msg_text">
            <CreateGroupDialog />
          </span>
        </span>
        <span class="me_msg_btn" @click="mymsg">
          <span class="me_msg_text">我的消息</span>
        </span>
        <span class="me_msg_btn" @click="addfriend">
          <span class="me_msg_text">添加好友</span>
        </span>
        <span class="me_msg_btn" @click="managefriend">
          <span class="me_msg_text">好友请求管理</span>
        </span>
      </div>
    </div>

    <div class="friends_con" v-loading="loading">
      <div v-if="hasFriends">
        <div
          class="friend_item"
          v-for="item in friendsList"
          :key="item.userId"
          @click="goChat(item)"
        >
          <div class="friend_item_info">
            <img class="fri_img" :src="item.imageUrl" />
            <span class="friend_name" v-if="item.remark">{{
              item.remark
            }}</span>
            <span class="friend_name" v-else>{{ item.userName }}</span>
          </div>
          <div class="friend_item_options" @click.stop>
            <el-popover
              placement="top"
              width="160"
              v-model="item.updateRemarkPopoverVisible"
            >
              <el-input
                v-model="item.updateRemarkText"
                placeholder="请输入新昵称"
              ></el-input>
              <div style="text-align: right; margin: 0">
                <el-button
                  size="mini"
                  type="text"
                  @click.stop="item.updateRemarkPopoverVisible = false"
                >
                  取消
                </el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click.stop="updateRemarkHandler(item)"
                >
                  确定
                </el-button>
              </div>
              <el-button type="text" slot="reference">
                {{ item.remark ? "修改" : "添加" }}备注
              </el-button>
            </el-popover>
          </div>
        </div>
      </div>
      <el-empty description="您还没有添加过好友" v-else />
    </div>
  </div>
</template>

<script>
import {
  GetFriendList,
  getFriendsByUseridAndKey,
  updateRemark,
} from "@/api/friend";
import CreateGroupDialog from "./CreateGroupDialog";

import { mapState, mapMutations } from "vuex";
import { getTmpChatList } from "@/api/chat";

export default {
  components: {
    CreateGroupDialog,
  },
  data() {
    return {
      searchInput: "", // 用于存储用户输入的搜索关键字
      tempFriend: null,
      messages: {},

      friendsList: [],
      loading: true,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    hasFriends() {
      return this.friendsList.length !== 0;
    },
    chatList() {
      return this.$store.state.msgContent.chat;
    },
  },
  activated() {
    // 页面重新激活时，重新加载好友列表
    this.loadFriendsList();
  },
  async mounted() {
    this.loadFriendsList();
  },
  methods: {
    // 将加载好友列表的逻辑提取到一个方法中
    async loadFriendsList() {
      this.loading = true;
      try {
        const res = await GetFriendList();
        console.log(res);
        if (res.code === 200) {
          this.friendsList = res.data.map((item) => {
            return {
              ...item,
              updateRemarkPopoverVisible: false,
              updateRemarkText: "",
            };
          });
          if (res.data.length > 0) {
            this.tempFriend = res.data[0];
          }
        }
        const chatData = await getTmpChatList({
          userId: this.userInfo.userId,
        });
        this.$store.state.msgContent.chat = chatData.data;
      } catch (error) {
        console.error("加载好友列表失败:", error);
      } finally {
        this.loading = false;
      }
    },
    goChat(userInfo) {
      let { userId, userName, imageUrl } = userInfo; // 检查chat是否包含当前用户
      if (!this.isUserInChat(userId)) {
        // 创建与该用户的聊天记录
        this.$store.state.msgContent[userId] = [];
        // 存入该用户信息
        this.$store.state.msgContent.chat.push({
          friendId: userId,
          friendName: userName,
          friendAvatar: imageUrl,
          unreadMessages: 0,
        });
      }
      // 将 tempFriendId 指向该用户
      // this.$store.state.msgContent.tempFriendInfo.friendId = userId
      console.log("-----userInfo-----", userInfo);
      // 格式不一致，需要从这里修正
      let nFriendInfo = {
        friendId: userInfo.userId,
        friendName: userInfo.userName,
        friendAvatar: userInfo.imageUrl,
        msg: null,
        unreadMessages: 0,
        type: 0, // 0单聊，1群聊
      };
      this.$store.state.msgContent.tempFriendInfo = nFriendInfo;
      // 路由到该页面
      this.$router.push({ name: "mymsg", params: { refresh: true } });
      // $store.state.msgContent.chat
    },
    // 检查聊天列表是否含某用户
    isUserInChat(userId) {
      console.log("--isUserInChat--", this.chatList, userId);
      for (let i = 0; i < this.chatList.length; i++) {
        console.log(this.chatList[i].friendId);
        if (this.chatList[i].friendId === userId) {
          return true;
        }
      }
      return false;
    },
    goTome() {
      this.$router.push({ name: "me" });
    },
    managefriend() {
      this.$router.push({ name: "managefriend", params: { refresh: true } });
    },
    addfriend() {
      var that = this;
      that.$router.push({ name: "addfriend", params: { refresh: true } });
    },
    mymsg() {
      var that = this;
      that.$router.push({ name: "mymsg", params: { refresh: true } });
    },
    mygroup() {
      var that = this;
      that.$router.push({ name: "mygroup", params: { refresh: true } });
    },

    getMessageList() {
      var that = this;
      getFriendsByUseridAndKey({ key: this.searchInput })
        .then((response) => {
          console.log(response.data);
          that.friendsList = response.data; // 使用搜索结果更新列表
        })
        .catch((error) => {
          console.error("搜索好友出错:", error);
        });
    },

    searchFriends() {
      var that = this;
      this.loading = true;
      getFriendsByUseridAndKey({ key: this.searchInput })
        .then((response) => {
          console.log(response.data);
          that.friendsList = response.data; // 使用搜索结果更新列表
        })
        .catch((error) => {
          console.error("搜索好友出错:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 修改备注
    updateRemarkHandler(userInfo) {
      updateRemark({
        remark: userInfo.updateRemarkText,
        friendId: userInfo.userId,
      }).then((res) => {
        this.$message.success(res.msg);
        this.updateRemarkPopoverVisible = false;
        this.loadFriendsList();
      });
    },
  },
};
</script>

<style>
.friend_name {
  margin-left: 14px;
  color: #333333;
  font-size: 18px;
}

.fri_img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
}

.friend_item {
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: solid 1px #cccccc;
}

.friend_item_info {
  display: flex;
  align-items: center;
}

.friend_item_options {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.friends_con {
  margin-top: 30px;
  background-color: white;
  height: 70vh;
}

.me_msg_btn {
  background-image: url("../assets/btnbg.png");
  width: 140px;
  height: 30px;
  color: white;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  font-size: 14px;
  font-weight: 550;
  margin-left: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.me_msg_text {
  padding-left: 6px;
}

.friends_sear_ops_con {
  display: flex;
  align-items: center;
}

.friends_start_col_btn {
  background-image: url("../assets/btnbg.png");
  width: 110px;
  height: 30px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: #ffffff;
  border: none;
  cursor: pointer;
  font-weight: 700;
}

.friend_add_in {
  margin-left: 5px;
  background: none;
  font-size: 18px;
  border: none;
  outline: none;
}

.friend_add_in_con {
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  border: solid 2px #0187ea;
  background-color: #edf7f9;
  width: 450px;
}

.friends_sear_con {
  display: flex;
  align-items: center;
}

.friends_sear {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.friends_tip_noac {
  color: #707070 !important;
}

.friends_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.friends_top_bar {
  display: flex;
  align-items: center;
}
</style>